import React from 'react'
import './waysToParticipate.scss'
import Title from '../../atoms/title/title'
import individual from '../../../assets/images/home/Pubertad.png'
import family from '../../../assets/images/home/Personajes_familia.png'
import Button from '../../atoms/button/button'
import { navigate } from 'gatsby-link'
import useMediaQuery from '../../../utils/useMediaQuery'

const WaysToParticipate = ({ isLogged }) => {
  const isMobile = useMediaQuery()

  return (
    <section className="f-section-ways-to-participate">
      <div className="f-section-ways-to-participate__wrapper">
        <Title color="yellow" txt={['Puedes', 'participar de dos', 'formas']} />
        <div className="f-section-ways-to-participate__content">
          <div className="f-section-ways-to-participate__individual">
            <div className="f-section-ways-to-participate__individual__description">
              <h3 className="f-section-ways-to-participate__title">
                Individual
              </h3>
              <p className="f-section-ways-to-participate__paragraph">
                Si ya tienes conocimientos acerca de la pubertad y quieres
                participar sola, aquí puedes seguir aprendiendo y conocer los
                productos Nosotras perfectos para ti.
              </p>
            </div>
            <div className="f-section-ways-to-participate__individual__img">
              <img src={individual} alt="Participación individual" />
            </div>
          </div>
          <div className="f-section-ways-to-participate__family">
            <div className="f-section-ways-to-participate__family__img">
              <img src={family} alt="Participación en familia" />
            </div>
            <div className="f-section-ways-to-participate__family__description">
              <h3 className="f-section-ways-to-participate__title">
                En familia
              </h3>
              <p className="f-section-ways-to-participate__paragraph">
                Participa con tus padres para que juntos conozcan lo que sucede
                en tu cuerpo mientras creces. Además, les mostraremos qué
                productos Nosotras te acompañan en cada etapa.
              </p>
            </div>
          </div>
        </div>
        <div className="f-section-ways-to-participate__btn">
          {!isMobile && (
            <Button
              color="purple"
              text={isLogged ? 'Ir a las actividades' : 'Participa'}
              action={() => navigate('actividades')}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default WaysToParticipate
